import { z } from 'zod';

export const PYTHON_PIPELINE_STAGE_EVENT = 'python-pipeline-stage';

export const PYTHON_PIPELINE_STAGES = [
  'resolving-secrets',
  'enforcing-guardrails',
  'executing',
] as const;

export const pythonPipelineStageSchema = z.enum(PYTHON_PIPELINE_STAGES);

export type PythonPipelineStage = z.infer<typeof pythonPipelineStageSchema>;

const pythonPipelineProgressSchema = z.looseObject({
  pythonPipeline: z.looseObject({ stage: z.string().optional() }).optional(),
});

const stageIndex = (stage: string): number => {
  const parsed = pythonPipelineStageSchema.safeParse(stage);

  return parsed.success ? PYTHON_PIPELINE_STAGES.indexOf(parsed.data) : -1;
};

const readProgress = (metadata: unknown): { stage?: string } | undefined => {
  const parsed = pythonPipelineProgressSchema.safeParse(metadata);

  return parsed.success ? parsed.data.pythonPipeline : undefined;
};

export const isStalePythonPipelineProgress = ({
  stored,
  incoming,
}: {
  stored: unknown;
  incoming: unknown;
}): boolean => {
  const incomingStage = readProgress(incoming)?.stage;

  if (!incomingStage) {
    return false;
  }

  const storedProgress = readProgress(stored);

  if (!storedProgress) {
    return false;
  }

  return (
    !storedProgress.stage ||
    stageIndex(storedProgress.stage) > stageIndex(incomingStage)
  );
};
